import { Component, Prop, Vue } from 'vue-property-decorator';
import { FEEDBACK_STATUSES, NOTIFICATION } from '@/constants';
import { FeedbackDTO } from '@/models';
import { updateFeedbackStatus } from '@/services';

@Component
export default class FeedbackRejectForm extends Vue {
  @Prop() feedback: FeedbackDTO;

  $refs!: {
    formRef: HTMLFormElement;
  };
  private ruleOptions = {
    description: [(v: string) => !!v || 'Reject reason is required']
  };

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  resetForm(): void {
    this.$refs.formRef.reset();
  }

  async onRejected(feedback: FeedbackDTO): Promise<void> {
    if (this.formValidate()) {
      const reqData: FeedbackDTO = {
        ...feedback,
        status: FEEDBACK_STATUSES.REJECTED.label,
        userId: feedback.user.id,
        rejectReason: feedback.rejectReason
      };
      const { data } = await updateFeedbackStatus(reqData);
      const notiInfo = {
        showing: true,
        type: data ? NOTIFICATION.TYPE.success : NOTIFICATION.TYPE.error,
        title: data ? NOTIFICATION.TEXT.rejectFeedbackSuccess : NOTIFICATION.TEXT.rejectFeedbackFailed,
        content: [],
        icon: data ? NOTIFICATION.ICON.success : NOTIFICATION.ICON.error,
        multiline: false,
        height: 0
      };
      this.$store.commit('notification/setNotification', notiInfo);

      if (data) {
        this.$emit('onDialogSave', data);
        this.onCancelRejectChange();
      }
    }
  }

  onCancelRejectChange(): void {
    this.resetForm();
    this.$emit('onCancelChanged', true);
  }
}
